import gql from 'graphql-tag';
export default gql`
  mutation selectSecondaryApplicant($applicantType: String!, $userInfo: UserInput!) {
    selectSecondaryApplicant(applicantType: $applicantType, userInfo: $userInfo) {
      status
      message
      secondaryApplicant {
        userId
        firstName
        lastName
        email
        phone
        confirmed
        identityVerificationStatus
        applicantType
      }
    }
  }
`;
